"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {default as initMap, setMarker, loadGoogleMapsAPI, showInfoBoxByMarker, closeInfoBoxByMarker} from "@elements/google-map";

export function initInScope($scope) {
    let checkCookie = setInterval(function(){
        if (window._etracker) {
            let mapsAcceptedByCookiebar = window._etracker.areCookiesEnabled();
            $scope.find('.js-dsgvo-map-hint__btn').on('click', function (evt) {
                $scope.find('[data-cookie-type="maps"]').remove();
                window._etracker.enableCookies();
                initDsgvoMap(true);
            });

            if(mapsAcceptedByCookiebar) {
                $scope.find('[data-cookie-type="maps"]').remove();
                initDsgvoMap(true);
            } else {
                initDsgvoMap(false);
                $scope.find('[data-cookie-type="maps"]').show();
            }
            clearInterval(checkCookie);
        }
    }, 200);

    function initDsgvoMap(cookieAccepted){
        let $maps  = $scope.find('.js-google-map');

        if ($maps && $maps.length && cookieAccepted) {
            $maps.each(function (index, element) {
                let $container = $(element);
                let $mapCanvas = $container.find('.js-google-map__canvas');
                onEnterViewPort($(element), function () {
                    loadGoogleMapsAPI().then(function () {
                        const poiStyles = {
                            default: {
                                default: {
                                    url: '/static/build/img/map/poi-dealer.svg',
                                    size: new google.maps.Size(40, 55),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(20, 47)
                                },
                                active: {
                                    url: '/static/build/img/map/poi-dealer-active.svg',
                                    size: new google.maps.Size(40, 55),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(20, 47)
                                }
                            }
                        };


                        let pois = _config.googleMapPOIs;
                        let options = {
                            zoom: 17,
                            scrollwheel: null,
                            gestureHandling: 'cooperative',
                            mapTypeControl: false,
                            streetViewControl: false,
                            fullscreenControl: false,
                        };

                        if (!pois) {
                            return;
                        }

                        let mapObj = initMap({
                            element: $mapCanvas[0],
                            mapOptions: options,
                            poiStyles,
                            clustering: false
                        });

                        setMarker(mapObj, pois);
                    }).catch(function (a,b,c) {
                        console.error(a,b,c);
                    });
                }, {
                    offset: window.innerHeight * 1.5
                })
            });
        }
    }
}